// css =>
import "../../BaseStructure.css";
import Styled from "./firstMenuBar.module.css";

// react =>
import { useEffect, useState, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";

// icons =>
import DownFlashIcon from "../../Assets/Icons/down-flash.png";

// components =>
import MobileSubMenu from "../mobileSubMenu/mobileSubMenu.comp";

function FirstMenuBar() {
    const navigate = useNavigate();
    const location = useLocation();

    const mobileMenuSelectBox = useRef<HTMLDivElement | null>(null);
    const [locationName, setLocationName] = useState<string>("مشخصات من");

    useEffect(() => {
        switch (location.pathname) {
            case "/edit-profile":
                setLocationName("مشخصات من");
            break;

            case "/shopping-card":
                setLocationName("سبد خرید");
            break;

            case "/favorites":
                setLocationName("مورد علاقه ها");
            break;

            case "/order-history":
                setLocationName("خرید ها");
            break;

            case "/order-show":
                setLocationName("وضعیت سفارش");
            break;
        }
    }, []);

    return(
        <>
            <div ref={ mobileMenuSelectBox } className={`row ${ Styled.SubMenuFrame } `}>
                <MobileSubMenu
                    key={ 0 }
                    subMenuOptions={["مشخصات من", "سبد خرید", "مورد علاقه ها", "خرید ها", "وضعیت سفارش"]}
                    onItemClick={(item) => {
                        switch(item) {
                            case "مشخصات من":
                                navigate("/edit-profile");
                                break;
                            case "سبد خرید":
                                navigate('/shopping-card');
                                break;
                            case "مورد علاقه ها":
                                navigate('/favorites');
                                break;
                            case "خرید ها":
                                navigate('/order-history');
                                break;
                            case "وضعیت سفارش":
                                navigate('/order-show');
                                break;
                        }
                    }}
                />
            </div>

            <div className={ Styled.FirstMenuFrameBox }>

                <div className={`row ${ Styled.FirstMenuFrameDesktop } `}>
                    <div
                        className={`col-3 ${location.pathname === "/edit-profile" ? Styled.active : ""}`}
                        onClick={() => navigate("/edit-profile")}
                    >
                        <h2>مشخصات من</h2>
                    </div>
                    <div
                        className={`col-3 ${location.pathname === "/shopping-card" ? Styled.active : ""}`}
                        onClick={() => navigate("/shopping-card")}
                    >
                        <h2>سبد خرید</h2>
                    </div>
                    <div
                        className={`col-3 ${location.pathname === "/favorites" ? Styled.active : ""}`}
                        onClick={() => navigate("/favorites")}
                    >
                        <h2>مورد علاقه ها</h2>
                    </div>
                    <div
                        className={`col-3 ${location.pathname === "/order-history" ? Styled.active : ""}`}
                        onClick={() => navigate("/order-history")}
                    >
                        <h2>خرید ها</h2>
                    </div>
                    <div
                        className={`col-3 ${location.pathname === "/order-show" ? Styled.active : ""}`}
                        onClick={() => navigate("/order-show")}
                    >
                        <h2>وضعیت سفارش</h2>
                    </div>
                </div>



                <div className={`row ${ Styled.FirstMenuFrameMobile } `} onClick={() => {
                    if(mobileMenuSelectBox.current) {
                        if (mobileMenuSelectBox.current.style.display == "flex") {
                            mobileMenuSelectBox.current.style.display = "none";
                        } else {
                            mobileMenuSelectBox.current.style.display = "flex";
                        }
                    }
                }}>
                    <div
                        className={`col-12`}>
                        <img src={ DownFlashIcon } alt="Down flash" />
                        <p>{ locationName }</p>
                    </div>
                </div>
            </div>
        </>
    );
}

export default FirstMenuBar;
